import {
  Component,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { shareShoutoutLink } from 'src/app/helpers/shareShoutoutLink';
import { EventStoreService } from 'src/app/services/stores/event.store.service';

@Component({
  selector: 'app-event-qr',
  templateUrl: './event-qr.component.html',
  styleUrls: ['./event-qr.component.scss'],
  standalone: false,
  providers: [EventStoreService],
})
export class EventQrComponent implements OnInit {
  private _route: ActivatedRoute = inject(ActivatedRoute);
  protected eventStoreService: EventStoreService = inject(EventStoreService);
  eventId: WritableSignal<string | null> = signal(null);
  qrWidth: number = 250;

  ngOnInit(): void {
    this.eventId.set(this._route.snapshot.paramMap.get('eventId'));
    this.eventStoreService.getById(this.eventId()!);
    const tempQrWidth = window.innerWidth * 0.9;
    this.qrWidth = tempQrWidth > 400 ? 400 : tempQrWidth;
  }

  shareLink(): string {
    return shareShoutoutLink(this.eventId()!);
  }

  printQRCode(): void {
    print();
  }

  lowestPrice(): string {
    const event = this.eventStoreService.event();
    const lowestPrice =
      event?.products
        ?.map((product) => product.amount)
        .reduce((a, b) => Math.min(a, b), Infinity) ??
      event?.pricing ??
      0;
    if (lowestPrice === Infinity) {
      return (event?.pricing ?? 0).toFixed(2);
    }
    return lowestPrice.toFixed(2);
  }
}
